"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const luxon_1 = require("luxon");
const FileReference_1 = require("../entity/FileReference");
class StubFileReference extends FileReference_1.default {
    constructor({ id = '123', mimetype = 'image/png', size = 1234567890, originalName = 'Rivermouth of the Sandbanks.png', url = `dummy://belfast-entity.kaizenplatform.com/files/${originalName}`, createdAt = luxon_1.DateTime.utc(2018, 6, 11, 9, 55, 47, 256), } = {}) {
        super({
            id,
            mimetype,
            size,
            originalName,
            createdAt,
            url,
        });
    }
}
exports.default = StubFileReference;
